import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import QtModal from "../../../components/Modal/QtModal";
import ArModal from "../../../components/Modal/ArModal";
import ItemTable from "../../../components/Content/ItemTable";
import Summary from "../../../components/Footer/Summary";
import FormAction from "../../../components/Actions/FormAction";
import PaymentModal from "../../../components/Modal/PaymentModal";

// Model
import { soMasterModel } from "../../../../model/SellProducts/SoMasterModel";
import { soDetailModel } from "../../../../model/SellProducts/SoDetailModel";

// Utils
import {
  getData,
  getDataWithComp,
  getByDocId,
  getDocType,
  getTransType,
  getAlert,
  formatCurrency,
  parseCurrency,
  getMaxDocNo,
  deleteData,
  randomDelay,
  getDataWithJoin,
  updateQty,
} from "../../../../utils/SamuiUtils";

import {
  formatStringDateToDate,
  formatDateOnChange,
  formatDateTime,
  formatThaiDateUi,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
} from "../../../../utils/DateUtils";

import { InvoiceHandleSubmit } from "../../../../utils/InvoiceUtils";

import { manageWhItemData } from "../../../../utils/WarehouseUtils";

function Form({
  callInitialize,
  mode,
  name,
  maxDocNo,
  onRowSelected,
  getReport,
}) {
  const [formMasterList, setFormMasterList] = useState(soMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [tbDocType, setTbDocType] = useState([]);
  const [tbTransType, setTbTransType] = useState([]);
  const [qtDataList, setQtDataList] = useState([]);
  const [arDataList, setArDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);

  // การแสดงสถานะเอกสาร
  const [statusTransportName, setStatusTransportName] = useState("");
  const [statusTransportColour, setStatusTransportColour] = useState("");
  const [statusPaidName, setStatusPaidName] = useState("");
  const [statusPaidColour, setStatusPaidColour] = useState("");
  const [statusPaidTypeName, setStatusPaidTypeName] = useState("");
  const [statusPaidTypeColour, setStatusPaidTypeColour] = useState("");

  // สำหรับเก็บประเภทการชำระเงิน
  const [paymentType, setPaymentType] = useState({});
  const [paymentAmount, setPaymentAmount] = useState({});

  // เก็บตัวแปรสำหรับเช็ค
  const [chequeNo, setChequeNo] = useState("");
  const [chequeName, setChequeName] = useState("");
  const [chequeBranch, setChequeBranch] = useState("");

  const [base64Image, setBase64Image] = useState("");

  // สำหรับเช็กเงื่อนไขว่าสร้างวางบิลหรือยัง ?
  const [isBl, setIsBl] = useState(false);

  // สำหรับตัวแปรดักป้องกันการกดซ้ำ
  const [isSubmitting, setIsSubmitting] = useState(false);

  // สำหรับ Freeze หน้าจอตอนทำรายการ
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      // เคลียร์ค่าทุกครั้งที่เปิดหน้าจอมา (แก้ปัญหา List ข้อมูลชอบค้าง)
      setFormMasterList(soMasterModel());
      setFormDetailList([]);

      const docTypeList = await getDocType(2);
      if (docTypeList && docTypeList.length > 0) {
        setTbDocType(docTypeList);
      }

      const transTypeList = await getTransType();
      if (transTypeList && transTypeList.length > 0) {
        setTbTransType(transTypeList);
      }

      const qtDataList = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/get-qt-by-so`,
        {
          comp_id: window.localStorage.getItem("company"),
        },
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );
      if (qtDataList.data && qtDataList.data.length > 0) {
        setQtDataList(qtDataList.data);
      }

      const arDataList = await getDataWithComp(
        "Tb_Set_AR",
        "ORDER BY AR_Code ASC"
      );
      if (arDataList && arDataList.length > 0) {
        setArDataList(arDataList);
      }

      const itemDataList = await getDataWithJoin(
        `item.*`,
        `Tb_Set_Item item`,
        `
          LEFT JOIN Tb_Set_ItmGroup grp ON (grp.Group_Id = item.Item_Group)
          WHERE item.Comp_Id = ${localStorage.getItem('company')} 
          AND grp.Comp_Id = ${localStorage.getItem('company')} 
          AND grp.Group_Code = 'G'
        `,
        `ORDER BY item.Item_Code ASC`
      );
      if (itemDataList && itemDataList.length > 0) {
        setItemDataList(itemDataList);
      }

      const whDataList = await getDataWithComp(
        "Tb_Set_Wh",
        `AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`
      );
      if (whDataList && whDataList.length > 0) {
        setWhDataList(whDataList);
      }

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo(arDataList);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const getModelByNo = async (arDataList) => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      const findMaster = await getDataWithComp("SO_H", ``);
      const fromDatabase = findMaster.find((so) => so.Doc_No === maxDocNo);

      if (!fromDatabase) {
        setIsLoading(false);
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายด้วย AR_ID
      const fromViewAr = arDataList.find(
        (ap) => ap.AR_Id === fromDatabase.AR_ID
      );

      if (!fromViewAr) {
        setIsLoading(false);
        throw new Error("ไม่พบข้อมูลลูกค้า");
      }

      // ค้นหาข้อมูล VIEW
      const findViewMaster = await getDataWithComp("API_0701_SO_H", "");
      const fromView = findViewMaster.find((data) => data.Doc_No === maxDocNo);
      setStatusTransportName(fromView.DocStatusTransport_Name);
      setStatusTransportColour(fromView.DocStatusTransport_Colour);
      setStatusPaidName(fromView.DocStatusPaid_Name);
      setStatusPaidColour(fromView.DocStatusPaid_Colour);
      setStatusPaidTypeName(fromView.DocStatusPaid_Type_Name);
      setStatusPaidTypeColour(fromView.DocStatusPaidType_Colour);

      // สำหรับเช็กเงื่อนไขว่าสร้างวางบิลหรือยัง ?
      const findBlBySoId = await getData('BL_D', `SO_Id = ${fromDatabase.Doc_Id}`);
      if (findBlBySoId && findBlBySoId.length > 0) {
        setIsBl(true);
      }

      // ฟังก์ชันเพื่อดึงข้อมูล itemOnHand และอัปเดตทีหลัง
      const updateItemOnHandLater = async (newRow, whId, itemId, itemQty) => {
        try {
          // ดึงข้อมูลทั้งหมดในครั้งเดียว
          const [findMaster, itemOnHandData, allDetails, allPkLists] =
            await Promise.all([
              getDataWithComp("SO_H", `AND Doc_Status = 1`),
              getDataWithComp(
                "API_1101_WH_ITEM_ONHAND",
                `AND WH_Id = ${parseCurrency(whId)} AND Item_Id = ${parseCurrency(itemId)}`
              ),
              getData(
                "SO_D",
                `WH_Id = ${parseCurrency(whId)} AND Item_Id = ${parseCurrency(itemId)}`
              ), // รวมเงื่อนไขทั้งหมด
              getData("PKList_D", "1 = 1"), // ดึงข้อมูล PKList ทั้งหมดทีเดียว
            ]);

          if (!itemOnHandData || itemOnHandData.length === 0) {
            newRow.itemOnHand = 0;
          } else {
            let newItemOnHand = parseCurrency(itemOnHandData[0].Item_Onhand);

            // สร้าง Map เพื่อเก็บ Doc_Id ที่อยู่ใน PKList
            const pkListMap = new Set(allPkLists.map((pk) => pk.SO_Id));

            // คำนวณ Item_Onhand ใหม่
            for (const master of findMaster) {
              if (!pkListMap.has(master.Doc_Id)) {
                const details = allDetails.filter(
                  (detail) => detail.Doc_ID === master.Doc_Id
                );
                for (const detail of details) {
                  newItemOnHand -= parseCurrency(detail.Item_Qty) || 0;
                }
              }
            }

            newItemOnHand += parseCurrency(itemQty) || 0;
            newRow.itemOnHand = newItemOnHand;
          }

          // อัปเดต UI
          setFormDetailList((prevDetails) =>
            prevDetails.map((detail) =>
              detail.itemId === newRow.itemId
                ? { ...detail, itemOnHand: newRow.itemOnHand }
                : detail
            )
          );
        } catch (error) {
          setIsLoading(false);
          getAlert("FAILED", error.message || error);
        }
      };

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        const itemDisType = String(itemSelected.Item_DisType);
        let itemTotal = itemQty * itemPriceUnit;

        itemTotal -=
          itemDisType === "2"
            ? (itemDiscount / 100) * itemTotal // ลดตามเปอร์เซ็นต์
            : itemDiscount; // ลดตามจำนวนเงิน

        const newRow = {
          ...soDetailModel(index + 1),
          dtId: itemSelected.DT_Id,
          docId: itemSelected.Doc_ID,
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit),
          itemDiscount: formatCurrency(itemDiscount),
          itemDisType,
          itemTotal,
          itemStatus: itemSelected.Item_Status,
          dsSeq: itemSelected.DS_SEQ,
          whId: itemSelected.WH_Id,

          itemOnHand: "-",
        };

        if (itemSelected.WH_Id != null) {
          updateItemOnHandLater(
            newRow,
            itemSelected.WH_Id,
            itemSelected.Item_Id,
            itemQty
          );
        }

        return newRow; // ส่ง newRow กลับทันที
      };

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromDetail = await getByDocId(
        "SO_D",
        fromDatabase.Doc_Id,
        `ORDER BY Item_Code ASC`
      );

      if (fromDetail.length > 0) {
        const newFormDetails = fromDetail.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );

        setFormDetailList(newFormDetails);

        setFormMasterList({
          docId: fromDatabase.Doc_Id,
          compId: fromDatabase.Comp_Id,
          docNo: fromDatabase.Doc_No,
          docDate: formatThaiDateUi(fromDatabase.Doc_Date || null),
          docStatus: fromDatabase.Doc_Status,
          docStatusTransport: fromDatabase.Doc_Status_Transport,
          docStatusReceive: fromDatabase.Doc_Status_Receive,
          docStatusPaid: fromDatabase.Doc_Status_Paid,
          docStatusPaidType: fromDatabase.Doc_Status_Paid_Type,
          docCode: fromDatabase.Doc_Code,
          docType: fromDatabase.Doc_Type,
          docFor: fromDatabase.Doc_For,
          docIsPickingList: fromDatabase.Doc_Is_PickingList,
          docIsInv: fromDatabase.Doc_Is_INV,
          docInvNo: fromDatabase.Doc_INV_No,
          docIsInvFrom: fromDatabase.Doc_Is_INV_From,
          refDocID: fromDatabase.Ref_DocID,
          refDoc: fromDatabase.Ref_Doc,
          refDocDate: formatThaiDateUi(fromDatabase.Ref_DocDate || null),
          refProjectID: fromDatabase.Ref_ProjectID,
          refProjectNo: fromDatabase.Ref_ProjectNo,
          transportType: fromDatabase.Transport_Type,
          docRemark1: fromDatabase.Doc_Remark1,
          docRemark2: fromDatabase.Doc_Remark2,
          arID: fromDatabase.AR_ID,
          arCode: fromDatabase.AR_Code,
          docDueDate: formatThaiDateUi(fromDatabase.Doc_DueDate || null),
          actionHold: fromDatabase.Action_Hold,
          discountValue: fromDatabase.Discount_Value,
          discountValueType: fromDatabase.Discount_Value_Type,
          discountCash: fromDatabase.Discount_Cash,
          discountCashType: fromDatabase.Discount_Cash_Type,
          discountTransport: fromDatabase.Discount_Transport,
          discountTransportType: fromDatabase.Discount_Transport_Type,
          isVat: fromDatabase.IsVat,
          docSEQ: fromDatabase.Doc_SEQ,
          creditTerm: fromDatabase.CreditTerm,
          creditTerm1Day: fromDatabase.CreditTerm1Day,
          creditTerm1Remark: fromDatabase.CreditTerm1Remark,
          creditTerm2Remark: fromDatabase.CreditTerm2Remark,
          accCode: fromDatabase.ACC_Code,
          empName: fromDatabase.EmpName,
          createdDate: setCreateDateTime(fromDatabase.Created_Date || null),
          createdByName: fromDatabase.Created_By_Name,
          createdById: fromDatabase.Created_By_Id,
          updateDate: setCreateDateTime(fromDatabase.Update_Date || null),
          updateByName: fromDatabase.Update_By_Name,
          updateById: fromDatabase.Update_By_Id,
          approvedDate: setCreateDateTime(fromDatabase.Approved_Date || null),
          approvedByName: fromDatabase.Approved_By_Name,
          approvedById: fromDatabase.Approved_By_Id,
          cancelDate: setCreateDateTime(fromDatabase.Cancel_Date || null),
          cancelByName: fromDatabase.Cancel_By_Name,
          cancelById: fromDatabase.Cancel_By_Id,
          approvedMemo: fromDatabase.Approved_Memo,
          printedStatus: fromDatabase.Printed_Status,
          printedDate: setCreateDateTime(fromDatabase.Printed_Date || null),
          printedBy: fromDatabase.Printed_By,
          docPaidPic: fromDatabase.Doc_Paid_Pic,
          payTotal: fromDatabase.Pay_Total,
          refBillNo: fromDatabase.Ref_Bill_No,
          docSoReceiveDate: formatThaiDateUi(fromDatabase.Doc_SO_Receive_Date || null),

          arName: fromViewAr.AR_Name,
          arAdd1: fromViewAr.AR_Add1,
          arAdd2: fromViewAr.AR_Add2,
          arAdd3: fromViewAr.AR_Add3,
          arProvince: fromViewAr.AR_Province,
          arZipcode: fromViewAr.AR_Zipcode,
          arTaxNo: fromViewAr.AR_TaxNo,
        });

        setIsVatChecked(fromDatabase.IsVat === 1);

        const discountValueType = parseCurrency(fromDatabase.Discount_Value_Type);
        if (!isNaN(discountValueType)) {
          setSelectedDiscountValueType(discountValueType.toString());
        }

        setSelectedDiscountValueType(String(fromDatabase.Discount_Value_Type));
      } else {
        setIsLoading(false);
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message || error);
    }
  };

  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    setSelectedDiscountValueType(
      selectedDiscountValueType === name ? null : name
    );
  };

  const handleSubmit = async () => {
    if (isSubmitting) return getAlert("FAILED", "กรุณารอสักครู่");
    setIsSubmitting(true);

    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
      await randomDelay();

      // หาค่าสูงของ DocNo ใน SO_H ก่อนบันทึก
      const findMaxDocNo = await getDataWithComp(
        "SO_H",
        "ORDER BY Doc_No DESC"
      );
      const maxDoc = getMaxDocNo(findMaxDocNo, "SO");
      let newMaxDoc = maxDoc;

      // ตรวจสอบค่า formMasterList.arID และ formMasterList.arCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        setIsSubmitting(false);
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsSubmitting(false);
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      let index = 0;
      for (const item of formDetailList) {
        // ทำการตรวจสอบจำนวนสินค้าที่สามารถขายได้อีกรอบ
        await handleChangeDetail(index, "whId", item.whId);

        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          setIsSubmitting(false);
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          setIsSubmitting(false);
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
        if (!item.whId) {
          setIsSubmitting(false);
          setIsLoading(false);
          getAlert(
            "FAILED",
            `ไม่สามารถบันทึกได้เนื่องจากไม่พบคลังสินค้าของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหาก whId เป็น 13 หรือไม่มีค่า
        }
        if (parseCurrency(item.itemQty) > parseCurrency(item.itemOnHand)) {
          setIsSubmitting(false);
          setIsLoading(false);
          getAlert(
            "FAILED",
            `จํานวนสินค้า ${item.itemName} ไม่พอ กรุณาทำรายการใหม่`
          );
          return; // หยุดการทำงานหากจํานวนสินค้ามากกว่าจํานวนคงเหลือ
        }

        index++;
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: newMaxDoc,
        doc_date: formatStringDateToDate(formMasterList.docDate),
        doc_status: parseCurrency("1", 10),
        doc_status_transport: parseCurrency("3", 10),
        doc_status_receive: parseCurrency("3", 10),
        doc_status_paid: parseCurrency("1", 10),
        doc_status_paid_type: null,
        doc_code: parseCurrency("7", 10),
        doc_type: formMasterList.docType,
        doc_for: formMasterList.docFor,
        doc_is_picking_list: 0,
        doc_is_inv: "N",
        doc_inv_no: null,
        doc_is_inv_from: parseCurrency("0", 10),
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_doc_date: formatThaiDateUiToDate(formMasterList.refDocDate),
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ar_id: parseCurrency(formMasterList.arID, 10),
        ar_code: formMasterList.arCode,
        doc_due_date: formatStringDateToDate(formMasterList.docDueDate),
        action_hold: parseCurrency("0", 10),
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: parseCurrency("0.00"),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseCurrency("0.00"),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: formMasterList.creditTerm1Day,
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: "0000",
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formMasterList.updateDate,
        update_by_name: formMasterList.updateByName,
        update_by_id: formMasterList.updateById,
        cancel_date: formMasterList.cancelDate,
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        printed_status: "N",
        printed_date: formMasterList.printedDate,
        printed_by: formMasterList.printedBy,
        pay_total: parseCurrency("0.00"),
        ref_bill_no: formMasterList.refBillNo,
        doc_so_receive_date: null,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-so-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (!base64Image) {
        const formData = {
          comp_id: window.localStorage.getItem("company"),
          doc_no: newMaxDoc,
          doc_paid_pic: base64Image,
        };
        await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/update-so-h-slip`, formData,
          { headers: { key: process.env.REACT_APP_ANALYTICS_KEY } }
        );
      }

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        const getDocIdResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-by-doc-no`,
          {
            table: "SO_H",
            doc_no: formMasterData.doc_no,
            comp_id: window.localStorage.getItem("company"),
          },
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        // ส่งข้อมูลรายละเอียดหากพบ Doc_Id
        if (getDocIdResponse && getDocIdResponse.data.length > 0) {
          const docId = parseCurrency(getDocIdResponse.data[0].Doc_Id, 10);

          const detailPromises = formDetailList.map(async (item, index) => {
            const formDetailData = {
              doc_id: parseCurrency(docId, 10),
              line: index + 1,
              item_id: item.itemId,
              item_code: item.itemCode,
              item_name: item.itemName,
              item_qty: parseCurrency(item.itemQty),
              item_unit: item.itemUnit,
              item_price_unit: parseCurrency(item.itemPriceUnit),
              item_discount: parseCurrency(item.itemDiscount),
              item_distype:
                item.itemDisType === "1"
                  ? parseCurrency("1", 10)
                  : parseCurrency("2", 10),
              item_total: parseCurrency(item.itemTotal),
              item_status: parseCurrency("1", 10),
              ds_seq: item.dsSeq,
              wh_id: item.whId,
            };

            return Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-so-d`,
              formDetailData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          });

          await Promise.all(detailPromises);
        }

        // ปรับยอดเงินออก
        // await manageWhArPaymentData(
        //   formMasterList.arID, // AR_ID ของลูกค้านั้นๆ
        //   formMasterList.arCode, // AR_Code ของสิ่งนั้นๆ
        //   formMasterList.arName, // ชื่อลูกค้าคนนั้นๆ
        //   0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
        //   "AO", // ประเภท เช่น AI/AO
        //   grandTotal, // ค่าจำนวนเงิน
        //   parseCurrency(getDocIdResponse.data[0].Doc_Id, 10), // ไอดีเอกสาร
        //   newMaxDoc, // เลขเอกสาร
        //   formMasterList.refDoc === null ? newMaxDoc : formMasterList.refDoc, // เลขเอกสารอ้างอิง
        //   null // หมายเหตุ
        // );

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      setIsSubmitting(false);
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    } finally {
      setIsSubmitting(false);
      setIsLoading(false);
    }
  };

  const [showPayTypeModal, setShowPayTypeModal] = useState(false);
  const handlePayTypeShow = () => setShowPayTypeModal(true);
  const handlePayTypeClose = () => {
    setShowPayTypeModal(false);
    setPaymentType({});
    setPaymentAmount({});
  };
  const handleUploadSlip = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleUpdate = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ตรวจสอบค่า formMasterList.arID และ formMasterList.arCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
        if (!item.whId) {
          setIsLoading(false);
          getAlert(
            "FAILED",
            `ไม่สามารถบันทึกได้เนื่องจากไม่พบคลังสินค้าของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหาก whId เป็น 13 หรือไม่มีค่า
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: formMasterList.docNo,
        doc_date: formatThaiDateUiToDate(formMasterList.docDate),
        doc_status: formMasterList.docStatus,
        doc_status_transport: formMasterList.docStatusTransport,
        doc_status_receive: formMasterList.docStatusReceive,
        doc_status_paid: parseCurrency(formMasterList.docStatusPaid, 10),
        doc_status_paid_type: parseCurrency(formMasterList.docStatusPaidType, 10),
        doc_code: formMasterList.docCode,
        doc_type: formMasterList.docType,
        doc_for: formMasterList.docFor,
        doc_is_picking_list: formMasterList.docIsPickingList,
        doc_is_inv: formMasterList.docIsInv,
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ar_id: formMasterList.arID,
        ar_code: formMasterList.arCode,
        doc_due_date: formatThaiDateUiToDate(formMasterList.docDueDate),
        action_hold: formMasterList.actionHold,
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: formMasterList.discountCash,
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: formMasterList.discountTransport,
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: formMasterList.creditTerm1Day,
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: formMasterList.accCode,
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        cancel_date: formMasterList.cancelDate,
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        printed_status: formMasterList.printedStatus,
        printed_date: formMasterList.printedDate,
        printed_by: formMasterList.printedBy,
        pay_total: formMasterList.payTotal,
        ref_bill_no: formMasterList.refBillNo,
        doc_so_receive_date: formatThaiDateUiToDate(formMasterList.docSoReceiveDate),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-so-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        const docId = parseCurrency(formMasterList.docId, 10);

        // ค้นหาใบขายใหม่อีกที
        const getOldSoDetail = await getDataWithComp(
          "API_0702_SO_D",
          `AND Doc_ID = ${docId}`
        );
        if (getOldSoDetail && getOldSoDetail.length > 0) {
          for (const soDetail of getOldSoDetail) {
            // #####################################
            // เอาเข้าคลังตามจำนวนสินค้าที่ใบขายเก่า
            // #####################################
            await manageWhItemData(
              soDetail.Item_Id, // Item ไอดีของสิ่งนั้นๆ
              soDetail.Item_Code, // Item โค้ดของสิ่งนั้นๆ
              soDetail.Item_Name, // ชื่อ Item นั้นๆ
              soDetail.WH_Id, // WarehouseID ของไอเทม
              "IN", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
              soDetail.Item_Qty, // ค่าจำนวนที่กรอกจากหน้าจอ
              docId, // ไอดีเอกสาร
              soDetail.Doc_No, // เลขเอกสาร
              soDetail.Ref_Doc === null
                ? soDetail.Doc_No
                : soDetail.Ref_Doc, // เลขเอกสารอ้างอิง
              "แก้ใบขาย" // หมายเหตุ
            );
          }
        }

        // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
        await deleteData("SO_D", `WHERE Doc_ID = ${formMasterList.docId}`);

        const detailPromises = formDetailList.map(async (item, index) => {
          const formDetailData = {
            doc_id: parseCurrency(docId, 10),
            line: index + 1,
            item_id: item.itemId,
            item_code: item.itemCode,
            item_name: item.itemName,
            item_qty: parseCurrency(item.itemQty),
            item_unit: item.itemUnit,
            item_price_unit: parseCurrency(item.itemPriceUnit),
            item_discount: parseCurrency(item.itemDiscount),
            item_distype: item.itemDisType,
            item_total: parseCurrency(item.itemTotal),
            item_status: parseCurrency("1"),
            ds_seq: item.dsSeq,
            wh_id: item.whId,
          };

          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-so-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        await Promise.all(detailPromises);

        for (const item of formDetailList) {
          // #####################################
          // เอาออกจากคลังตามจำนวนสินค้าที่ใบขาย
          // #####################################
          await manageWhItemData(
            item.itemId, // Item ไอดีของสิ่งนั้นๆ
            item.itemCode, // Item โค้ดของสิ่งนั้นๆ
            item.itemName, // ชื่อ Item นั้นๆ
            item.whId, // WarehouseID ของไอเทม
            "OUT", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
            item.itemQty, // ค่าจำนวนที่กรอกจากหน้าจอ
            docId, // ไอดีเอกสาร
            formMasterList.docNo, // เลขเอกสาร
            formMasterList.refDoc === null
              ? formMasterList.docNo
              : formMasterList.refDoc, // เลขเอกสารอ้างอิง
            "ขายสินค้า" // หมายเหตุ
          );
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };
  const handleUpdatePayment = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ตรวจสอบค่าว่าเลือกประเภทการชำระเงินหรือยัง
      if (!paymentType) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกประเภทการชำระเงิน");
        return; // หยุดการทำงานของฟังก์ชันหากไม่ได้เลือกประเภทการชำระเงิน
      }

      let docStatusPaid;
      const totalPaidAmount =
        (paymentType.cash ? parseCurrency(paymentAmount.cash) : 0) +
        (paymentType.transfer ? parseCurrency(paymentAmount.transfer) : 0) +
        (paymentType.cheque ? parseCurrency(paymentAmount.cheque) : 0) +
        (paymentType.credit ? parseCurrency(paymentAmount.credit) : 0) +
        (paymentType.unpaid ? parseCurrency(paymentAmount.unpaid) : 0);

      if (paymentType.credit || paymentType.unpaid) {
        docStatusPaid = 2; // ค้างจ่าย
      } else if (totalPaidAmount < grandTotal) {
        docStatusPaid = 2; // ค้างจ่าย
      } else {
        docStatusPaid = 3; // จ่ายครบ
      }

      // ตรวจสอบช่องทางที่ถูกเลือก
      let docStatusPaidType = 6;
      const selectedMethods = Object.keys(paymentType).filter(
        (method) => paymentType[method]
      );

      if (selectedMethods.length === 1) {
        const method = selectedMethods[0];
        const paymentTypeMap = {
          cash: 1,
          transfer: 2,
          cheque: 3,
          credit: 4,
          unpaid: 5,
        };
        docStatusPaidType = paymentTypeMap[method] || 6;
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formPaidData = {
        doc_status: parseCurrency("2", 10),
        doc_status_paid: parseCurrency(docStatusPaid, 10),
        doc_status_paid_type: parseCurrency(docStatusPaidType, 10),
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        doc_no: formMasterList.docNo,
        comp_id: window.localStorage.getItem("company"),
        doc_paid_pic: base64Image,
        pay_total: parseCurrency(totalPaidAmount || 0.00),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-so-paid`,
        formPaidData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        // ถ้าจ่ายครบแล้ว
        // if (paidStatus === 3) {
        //   // ค้นหาข้อมูลล่าสุด และทำการอัพเดตค่าใน PAYMENT_ONHAND & PAYMENT_STC
        //   const getOldData = await getDataWithComp(
        //     "API_0701_SO_H",
        //     `AND Doc_ID = ${formMasterList.docId}`
        //   );
        //   if (getOldData && getOldData.length > 0) {
        //     const data = getOldData[0];

        //     // ปรับยอดเงินเข้า
        //     await manageWhArPaymentData(
        //       data.AR_ID, // AR_ID ของลูกค้านั้นๆ
        //       data.AR_Code, // AR_Code ของสิ่งนั้นๆ
        //       data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
        //       0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
        //       "AI", // ประเภท เช่น AI/AO
        //       data.NetTotal, // ค่าจำนวนเงิน
        //       data.Doc_ID, // ไอดีเอกสาร
        //       data.Doc_No, // เลขเอกสาร
        //       data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
        //       await setRemarkByPaymentType(parseCurrency(data.Doc_Status_Paid_Type)), // หมายเหตุ
        //     );
        //   }
        // }

        const docId = parseCurrency(formMasterList.docId, 10);

        for (const item of formDetailList) {
          // #####################################
          // เอาออกจากคลังตามจำนวนสินค้าที่ใบขาย
          // #####################################
          await manageWhItemData(
            item.itemId, // Item ไอดีของสิ่งนั้นๆ
            item.itemCode, // Item โค้ดของสิ่งนั้นๆ
            item.itemName, // ชื่อ Item นั้นๆ
            item.whId, // WarehouseID ของไอเทม
            "OUT", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
            item.itemQty, // ค่าจำนวนที่กรอกจากหน้าจอ
            docId, // ไอดีเอกสาร
            formMasterList.docNo, // เลขเอกสาร
            formMasterList.refDoc === null
              ? formMasterList.docNo
              : formMasterList.refDoc, // เลขเอกสารอ้างอิง
            "ขายสินค้า" // หมายเหตุ
          );
        }

        // ทำการเช็กว่าใบขายนี้ มีใบกำกับภาษีหรือไม่ ถ้ามีต้องอัพเดทตัวสถานะจ่ายให้ด้วย
        const getInvoice = await getDataWithComp(
          "INV_H", `AND Doc_Is_INV_From = 1 AND Ref_DocID = ${docId}`
        );
        if (getInvoice && getInvoice.length > 0) {
          const invoice = getInvoice[0];
          await updateQty(
            "INV_H",
            `Doc_Status_Paid = ${formPaidData.doc_status_paid} , Doc_Status_Paid_Type = ${formPaidData.doc_status_paid_type}`,
            `WHERE Doc_Id = ${invoice.Doc_Id}`
          );
          console.debug("อัพเดท INV สำเร็จ (อย่าลืมมาลบ Log ด้วย)");
        }

        const paymentTypeMap = {
          cash: 1,
          transfer: 2,
          cheque: 3,
          credit: 4,
          unpaid: 5,
        };

        for (const method of Object.keys(paymentType)) {
          if (paymentType[method]
            && paymentAmount[method] > 0
            && (paymentTypeMap[method] === 1 || paymentTypeMap[method] === 2 || paymentTypeMap[method] === 3)
          ) {
            const formPaymentHistoryData = {
              doc_code_id: 7,
              doc_id: docId,
              pay_type: paymentTypeMap[method],
              pay_amount: paymentAmount[method],
              pay_remark: null,
              pay_datetime: new Date(),
              pay_by: localStorage.getItem("name"),
              pay_to_acc_no: null,
              pay_to_branch: null,
              pay_to_acc_name: null,
              pay_cheque_no: paymentTypeMap[method] === 3 ? chequeNo : null,
              pay_cheque_name: paymentTypeMap[method] === 3 ? chequeName : null,
              pay_cheque_branch: paymentTypeMap[method] === 3 ? chequeBranch : null,
              pay_cheque_type: null,
            };

            // ส่งข้อมูลไปยัง API
            await Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-pay-history`,
              formPaymentHistoryData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          }
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };
  // ใช้สำหรับปรับสถานะที่เป็น 'ค้างจ่าย' ให้เป็น 'จ่ายครบ' (เฉพาะเครดิต และ เช็ค)
  const handleUpdatePaidStatus = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formUpdateData = {
        doc_status_paid: parseCurrency("3", 10),
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        doc_no: formMasterList.docNo,
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-so-paid-complete`,
        formUpdateData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        // ค้นหาข้อมูลล่าสุด และทำการอัพเดตค่าใน PAYMENT_ONHAND & PAYMENT_STC
        // const getOldData = await getDataWithComp(
        //   "API_0701_SO_H",
        //   `AND Doc_ID = ${formMasterList.docId}`
        // );
        // if (getOldData && getOldData.length > 0) {
        //   const data = getOldData[0];

        //   // ปรับยอดเงินเข้า
        //   await manageWhArPaymentData(
        //     data.AR_ID, // AR_ID ของลูกค้านั้นๆ
        //     data.AR_Code, // AR_Code ของสิ่งนั้นๆ
        //     data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
        //     0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
        //     "AI", // ประเภท เช่น AI/AO
        //     data.NetTotal, // ค่าจำนวนเงิน
        //     data.Doc_ID, // ไอดีเอกสาร
        //     data.Doc_No, // เลขเอกสาร
        //     data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
        //     await setRemarkByPaymentType(parseCurrency(data.Doc_Status_Paid_Type)), // หมายเหตุ
        //   );
        // }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-so-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // คืนสต็อกคลัง เมื่อทำการยกเลิก (คุณทรายแจ้งมา)
      const findOldDetail = await getDataWithComp('API_0702_SO_D', `AND Doc_No = '${formMasterList.docNo}' ORDER By Line ASC`);
      if (findOldDetail && findOldDetail.length > 0) {
        for (const dataDetail of findOldDetail) {
          // ย้ายเข้า
          await manageWhItemData(
            dataDetail.Item_Id, // Item ไอดีของสิ่งนั้นๆ
            dataDetail.Item_Code, // Item โค้ดของสิ่งนั้นๆ
            dataDetail.Item_Name, // ชื่อ Item นั้นๆ
            dataDetail.WH_Id, // WarehouseID ของไอเทม
            "AI", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
            parseCurrency(dataDetail.Item_Qty), // ค่าจำนวนที่กรอกจากหน้าจอ
            dataDetail.Doc_ID, // ไอดีเอกสาร
            dataDetail.Doc_No, // เลขเอกสาร
            dataDetail.Ref_Doc === null ? dataDetail.Doc_No : dataDetail.Ref_Doc, // เลขเอกสารอ้างอิง
            `ยกเลิกใบ : ${dataDetail.Doc_No}` // หมายเหตุ
          );
        }
      }

      callInitialize();
      getAlert(response.data.status, response.data.message);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleTax = async () => {
    try {
      const response = await InvoiceHandleSubmit(
        "SO", // BI = ใบวางบิล, SO = ใบขาย
        formMasterList.arID, // arId
        formMasterList.arCode, // arCode
        formMasterList.arName, // arName
        formMasterList.arTaxNo, // arTaxNo
        formMasterList.arAdd1, // arAdd1
        formMasterList.arAdd2, // arAdd2
        formMasterList.arAdd3, // arAdd3
        formMasterList.arProvince, // arProvince
        formMasterList.arZipcode, // arZipcode
        null, // arContact1
        null, // arContact2
        null, // arTel1
        null, // arTel2
        formMasterList.docDate, // docDate
        formMasterList.docFor, // docFor
        formMasterList.docId, // refDocId
        formMasterList.docNo, // refDoc
        formMasterList.docDate, // refDocDate
        formMasterList.docRemark1, // docRemark1
        isVatChecked // isVat
      );

      await onRowSelected(formMasterList.docNo);
      await getModelByNo(arDataList);
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdateSlip = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ตรวจสอบค่า formMasterList.arID และ formMasterList.arCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
        if (!item.whId) {
          setIsLoading(false);
          getAlert(
            "FAILED",
            `ไม่สามารถบันทึกได้เนื่องจากไม่พบคลังสินค้าของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหาก whId เป็น 13 หรือไม่มีค่า
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: formMasterList.docNo,
        doc_paid_pic: base64Image,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-so-h-slip`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        callInitialize();
        getAlert(response.data.status, response.data.message);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    // ตรวจสอบว่า value เป็น moment object หรือไม่
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;

    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: formatDateOnChange(newValue),
    }));
  };

  const handleChangeDetail = async (index, field, value) => {
    // ตรวจสอบว่าค่าที่กรอกเข้ามาเป็นตัวเลขหรือตัวเลขที่มีจุดทศนิยม
    if (!/^\d*\.?\d*$/.test(value)) {
      //getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");
      return;
    }

    const updatedList = [...formDetailList];
    updatedList[index][field] = value;

    // -------------------------------------------
    // (กรณี itemQty เดิม ที่ต้องเช็ค stock)
    if (
      field === "itemQty" &&
      (formDetailList[index].itemOnHand === null ||
        formDetailList[index].itemOnHand === undefined)
    ) {
      getAlert("FAILED", "กรุณาเลือกคลังก่อน");
      return;
    }

    if (field === "itemQty" && parseCurrency(value) > parseCurrency(formDetailList[index].itemOnHand)) {
      updatedList[index].itemQty = parseCurrency(formDetailList[index].itemOnHand);
      setTimeout(() => {
        handleBlur(index, 'itemQty', String(parseCurrency(formDetailList[index].itemOnHand)));
      }, 0);
      getAlert("FAILED", "ไม่สามารถใส่จำนวนเกินกว่าจำนวนคงคลังได้");
      return;
    }

    const itemQty = parseCurrency(updatedList[index].itemQty) || 0;
    const itemPriceUnit = parseCurrency(updatedList[index].itemPriceUnit) || 0;
    const itemDiscount = parseCurrency(updatedList[index].itemDiscount) || 0;
    const itemDisType = String(updatedList[index].itemDisType);

    let itemTotal = itemQty * itemPriceUnit;
    itemTotal -=
      itemDisType === "2" ? (itemDiscount / 100) * itemTotal : itemDiscount;
    updatedList[index].itemTotal = itemTotal;

    if (field === "whId") {
      updatedList[index].itemOnHand = "-";

      const [findMaster, itemOnHand] = await Promise.all([
        getDataWithComp("SO_H", `AND Doc_Status = 1`),
        getDataWithComp(
          "API_1101_WH_ITEM_ONHAND",
          `AND WH_Id = ${parseCurrency(value)} AND Item_Id = ${updatedList[index].itemId
          }`
        ),
      ]);

      let newItemOnHand = 0;
      if (itemOnHand && itemOnHand.length > 0) {
        newItemOnHand = parseCurrency(itemOnHand[0].Item_Onhand);

        if (findMaster && findMaster.length > 0) {
          for (const master of findMaster) {
            const [findDetail, findPkList] = await Promise.all([
              getData(
                "SO_D",
                `Doc_ID = ${master.Doc_Id} AND WH_Id = ${parseCurrency(
                  value
                )} AND Item_Id = ${updatedList[index].itemId}`
              ),
              getData("PKList_D", `SO_Id = ${master.Doc_Id}`),
            ]);

            if (!findPkList || findPkList.length === 0) {
              for (const detail of findDetail) {
                newItemOnHand -= parseCurrency(detail.Item_Qty) || 0;
              }
            }
          }
        }
      }

      // ดักเงื่อนไขว่า ถ้า itemQty มากกว่า itemOnHand ให้เคลียร์ค่า itemQty
      if (parseCurrency(itemQty) > parseCurrency(newItemOnHand)) {
        updatedList[index].itemQty = formatCurrency("0.00");
      }

      updatedList[index].itemOnHand = newItemOnHand;
    }

    setFormDetailList(updatedList);
  };

  const handleFocus = (index, field) => {
    const updatedList = [...formDetailList];
    updatedList[index][field] = parseCurrency(updatedList[index][field].replace(/,/g, "")) || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(numericValue);

    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };

  // SET QT
  const [showQtModal, setShowQtModal] = useState(false);
  const handleQtShow = () => setShowQtModal(true);
  const handleQtClose = () => setShowQtModal(false);
  const onRowSelectQt = async (qtSelected) => {
    try {
      // เคลียร์ค่าใน formMasterList และ formDetailList
      setFormMasterList({});
      setFormDetailList([]);

      // ค้นหาข้อมูลที่ตรงกับ prSelected.Doc_No ใน PR_H และ AP_ID ใน apDataList
      const [fromViewMaster, fromViewAr] = await Promise.all([
        getDataWithComp("API_0601_QT_H", "ORDER BY Doc_No DESC"),
        arDataList.find((ar) => ar.AR_Id === qtSelected.AR_ID),
      ]);

      const fromViewQt = fromViewMaster.find(
        (qt) => qt.Doc_No === qtSelected.Doc_No
      );

      if (!fromViewQt || !fromViewAr) {
        throw new Error("ไม่พบข้อมูล");
      }

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        let itemTotal = itemQty * itemPriceUnit;

        if (itemSelected.Item_DisType === 2) {
          itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
        } else {
          itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
        }

        return {
          ...soDetailModel(index + 1),
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit),
          itemDiscount: formatCurrency(itemDiscount),
          itemDisType: String(itemSelected.Item_DisType),
          itemTotal,
          itemStatus: itemSelected.Item_Status,
          whId: itemSelected.WH_ID,
          whName: itemSelected.WH_Name,
          zoneId: itemSelected.Zone_ID,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
        };
      };

      const getAllItem = await getDataWithComp(
        "API_0602_QT_D",
        "ORDER BY Line ASC"
      );
      const filterItem = getAllItem.filter(
        (item) => item.Doc_No === qtSelected.Doc_No
      );

      if (filterItem.length > 0) {
        const newFormDetails = filterItem.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );

        setFormDetailList(newFormDetails);

        const firstItem = filterItem[0];

        setFormMasterList({
          ...formMasterList,
          refDocID: fromViewQt.Doc_ID,
          refDoc: fromViewQt.Doc_No,
          refDocDate: formatThaiDateUi(fromViewQt.Doc_Date),
          docDate: formatThaiDateUi(moment()),
          docDueDate: formatThaiDateUi(moment()),
          docRemark1: fromViewQt.Doc_Remark1,
          docRemark2: fromViewQt.Doc_Remark2,
          docType: fromViewQt.Doc_Type,
          docFor: fromViewQt.Doc_For,
          transportType: fromViewQt.Transport_Type,
          discountValue: fromViewQt.Discount_Value,
          creditTerm: firstItem.CreditTerm,
          arID: fromViewQt.AR_ID,
          arCode: firstItem.AR_Code,
          arName: firstItem.AR_Name,
          arAdd1: firstItem.AR_Add1,
          arAdd2: firstItem.AR_Add2,
          arAdd3: firstItem.AR_Add3,
          arProvince: firstItem.AR_Province,
          arZipcode: firstItem.AR_Zipcode,
          arTaxNo: firstItem.AR_TaxNo,
        });

        setIsVatChecked(fromViewQt.IsVat === 1 ? true : false);

        const discountValueType = parseCurrency(fromViewQt.Discount_Value_Type);
        if (!isNaN(discountValueType)) {
          setSelectedDiscountValueType(discountValueType.toString());
        }
      } else {
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${qtSelected.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }

      handleQtClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  // SET AR
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = (arSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        arID: arSelected.AR_Id,
        arCode: arSelected.AR_Code,
        arName: arSelected.AR_Name,
        arAdd1: arSelected.AR_Add1,
        arAdd2: arSelected.AR_Add2,
        arAdd3: arSelected.AR_Add3,
        arProvince: arSelected.AR_Province,
        arZipcode: arSelected.AR_Zipcode,
        arTaxNo: arSelected.AR_TaxNo,
      });

      // ถ้าลูกค้ามี VAT ให้ Default VAT
      if (parseCurrency(arSelected.AR_Vat) === 1) {
        setIsVatChecked(true);
      }

      handleArClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const onRowSelectItem = (itemsSelected) => {
    try {
      // ใช้ Set เพื่อกรอง Item_Id ที่ซ้ำกัน
      // const uniqueItems = Array.from(
      //   new Set(itemsSelected.map(item => item.Item_Id))
      // ).map(id => {
      //   return itemsSelected.find(item => item.Item_Id === id);
      // });

      // แปลงข้อมูลที่กรองแล้วให้อยู่ในรูปแบบที่ต้องการ
      const updatedFormDetailList = itemsSelected.map((itemSelected) => ({
        line: null,
        itemId: itemSelected.Item_Id,
        itemCode: itemSelected.Item_Code,
        itemName: itemSelected.Item_Name,
        itemQty: formatCurrency(0),
        itemOnHand: formatCurrency(0),
        itemUnit: itemSelected.Item_Unit_ST,
        itemPriceUnit: formatCurrency(itemSelected.Item_Price || 0),
        itemDiscount: formatCurrency(0),
        itemDisType: "1",
        itemTotal: 0,
        itemStatus: itemSelected.Item_Status,
        whId: null,
        whName: itemSelected.WH_Name,
        zoneId: null,
        ltId: null,
        dsSeq: formatDateTime(new Date()),
      }));

      // อัปเดต formDetailList ด้วยข้อมูลที่กรองแล้ว
      setFormDetailList(updatedFormDetailList);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };
  const handleDuplicateRow = (index) => {
    const newItem = { ...formDetailList[index] };
    const newList = [
      ...formDetailList.slice(0, index + 1),
      newItem,
      ...formDetailList.slice(index + 1),
    ];
    setFormDetailList(newList);
  };
  const handleRemoveRow = (index) => {
    const newList = formDetailList.filter((_, i) => i !== index);
    setFormDetailList(newList);
  };
  const handleVatChange = () => {
    setIsVatChecked((prev) => !prev);
  };

  // SET WAREHOUSE
  const [showWarehouseModal, setShowWarehouseModal] = useState(false);
  const handleWarehouseShow = () => setShowWarehouseModal(true);
  const handleWarehouseClose = () => setShowWarehouseModal(false);
  const onRowSelectWh = async (whSelected) => {
    // สำหรับ Freeze หน้าจอตอนทำรายการ
    setIsLoading(true);

    handleWarehouseClose();

    if (formDetailList && formDetailList.length > 0) {
      for (let index = 0; index < formDetailList.length; index++) {
        handleChangeDetail(index, "whId", whSelected.WH_Id);
      }
    } else {
      setIsLoading(false);
      getAlert("FAILED", "กรุณาเลือกสินค้าก่อน");
    }

    setIsLoading(false);
  };

  // การคำนวณยอดรวม (totalPrice)
  useEffect(() => {
    const total = formDetailList.reduce(
      (acc, item) => acc + (parseCurrency(item.itemTotal) || 0),
      0
    );
    setTotalPrice(total);
  }, [formDetailList]);

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    let discountValue = parseCurrency(formMasterList.discountValue || 0);
    let receiptDiscount = 0;

    if (selectedDiscountValueType === "2") {
      // เปอร์เซ็นต์
      receiptDiscount = (totalPrice / 100) * discountValue;
    } else if (selectedDiscountValueType === "1") {
      // จำนวนเงิน
      receiptDiscount = discountValue;
    }

    setReceiptDiscount(receiptDiscount);
  }, [totalPrice, formMasterList.discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    const vat = isVatChecked ? subFinal * 0.07 : 0;
    setVatAmount(parseCurrency(vat.toFixed(2)));
  }, [subFinal, isVatChecked]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const grandTotal = subFinal + vatAmount;
    setGrandTotal(parseCurrency(grandTotal));
  }, [subFinal, vatAmount]);

  return (
    <>
      <div
        hidden={
          window.location.pathname === "/bill" ||
          window.location.pathname === "/picking-list"
        }
      >
        <Breadcrumbs
          page={maxDocNo}
          isShowStatus={mode === "U"}
          statusName={statusTransportName}
          statusColour={statusTransportColour}
          otherStatusName={statusPaidName}
          otherStatusColour={statusPaidColour}
          otherTypeName={statusPaidTypeName}
          otherTypeColour={statusPaidTypeColour}
          items={[
            { name: "ขายสินค้า", url: "/sellproducts" },
            { name: name, url: "/billofsale" },
            {
              name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name,
              url: "#",
            },
          ]}
          docIsINV={formMasterList.docIsInv}
          onHandleClick={() => getReport("so", formMasterList.docNo)}
          onHandlePayslip={() => getReport("rc", formMasterList.docNo)}
          onHandleInvoice1={() => getReport("inv1", formMasterList.docInvNo)}
          onHandleInvoice2={() => getReport("inv2", formMasterList.docInvNo)}
          urlImg={formMasterList.docPaidPic}
          handleUploadSlip={handleUploadSlip}
          base64Image={base64Image}
          setBase64Image={setBase64Image}
          handleUpdateSlip={handleUpdateSlip}
          docInvNo={formMasterList.docInvNo}
        />
      </div>

      {/* Loading Spinner */}
      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <div
        className="hidden-scrollbar"
        style={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        <div className="row mt-1">
          <div className="col-3 text-left">
            <div className="d-flex align-items-center">
              <label>วันที่เอกสาร</label>
              <Datetime
                className="input-spacing-input-date"
                name="docDate"
                value={formMasterList.docDate || null}
                onChange={(date) => handleChangeDateMaster(date, "docDate")}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{ readOnly: true, disabled: mode === "U" }}
              />
            </div>
          </div>
          <div className="col-4 text-left">
            <div className="d-flex align-items-center">
              <label>ลูกค้า</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="apCode"
                  value={
                    (formMasterList.arCode || "") +
                    " " +
                    (formMasterList.arName || "")
                  }
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleArShow}
                  disabled={mode === "U" ? true : false}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <ArModal
              showArModal={showArModal}
              handleArClose={handleArClose}
              arDataList={arDataList}
              onRowSelectAr={onRowSelectAr}
            />
          </div>
          <div className="col-2"></div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdDate"
                value={formMasterList.createdDate}
                // onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>อ้างอิงเอกสาร</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="refDoc"
                  value={formMasterList.refDoc || ""}
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleQtShow}
                  disabled={mode === "U"}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
              <QtModal
                showQtModal={showQtModal}
                handleQtClose={handleQtClose}
                qtDataList={qtDataList}
                onRowSelectQt={onRowSelectQt}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ที่อยู่</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="apAdd1"
                value={formMasterList.arAdd1 || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdByName"
                value={formMasterList.createdByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วันที่เอกสารอ้างอิง</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="refDocDate"
                value={formMasterList.refDocDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.arAdd2 || "") +
                  " " +
                  (formMasterList.arAdd3 || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formMasterList.updateDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>ประเภทเอกสาร</label>
              <select
                className="form-select form-control input-spacing"
                name="docType"
                value={formMasterList.docType}
                onChange={handleChangeMaster}
                disabled={
                  formMasterList.docStatusPaid === 3 ||
                    window.location.pathname === "/bill"
                    ? true
                    : false
                }
              >
                {tbDocType.map((docType) => (
                  <option key={docType.DocType_Id} value={docType.DocType_Id}>
                    {docType.DocType_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.arProvince || "") +
                  " " +
                  (formMasterList.arZipcode || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้แก้ไขเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateByName"
                value={formMasterList.updateByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            {/* <div className="d-flex align-items-center">
            <label>วัตถุประสงค์</label>
            <select
              name="docFor"
              value={formMasterList.docFor}
              onChange={handleChangeMaster}
              className="form-select form-control input-spacing"
              disabled={
                formMasterList.docStatusPaid === 3 ||
                  window.location.pathname === "/bill"
                  ? true
                  : false
              }
            >
              <option value="1">ซื้อมาเพื่อใช้</option>
              <option value="2">ซื้อมาเพื่อขาย</option>
            </select>
          </div> */}
            <div className="d-flex align-items-center">
              <label>Due Date</label>
              <Datetime
                className="input-spacing-input-date"
                name="docDueDate"
                value={formMasterList.docDueDate || null}
                onChange={(date) => handleChangeDateMaster(date, "docDueDate")}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{
                  readOnly: true,
                  disabled:
                    formMasterList.docStatusPaid === 3 ||
                      window.location.pathname === "/bill"
                      ? true
                      : false,
                }}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>เลขที่ภาษี</label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.arTaxNo || ""}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right" />
        </div>
        <div className="row mt-1">
          <div className="col-3">
            {/* <div className="d-flex align-items-center">
            <label>Due Date</label>
            <Datetime
              className="input-spacing-input-date"
              name="docDueDate"
              value={formMasterList.docDueDate || null}
              onChange={(date) => handleChangeDateMaster(date, "docDueDate")}
              dateFormat="DD-MM-YYYY"
              timeFormat={false}
              inputProps={{
                readOnly: true,
                disabled:
                  formMasterList.docStatusPaid === 3 ||
                    window.location.pathname === "/bill"
                    ? true
                    : false,
              }}
            />
          </div> */}
          </div>
          <div className="col-6" />
          <div className="col-3 text-right">
            {/* <div className="d-flex align-items-center">
            <label>ผู้อนุมัติเอกสาร</label>
            <input
              type="text"
              className="form-control input-spacing"
              name="approvedByName"
              value={formMasterList.approvedByName || ""}
              onChange={handleChangeMaster}
              disabled={true}
            />
          </div> */}
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วิธีจัดส่ง</label>
              <select
                name="transportType"
                value={formMasterList.transportType}
                onChange={handleChangeMaster}
                className="form-select form-control input-spacing"
                disabled={
                  formMasterList.docStatusPaid === 3 ||
                    window.location.pathname === "/bill"
                    ? true
                    : false
                }
              >
                {tbTransType.map((transType) => (
                  <option
                    key={transType.Trans_TypeID}
                    value={transType.Trans_TypeID}
                  >
                    {transType.Trans_TypeName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>อ้างอิงเลขบิล</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="refBillNo"
                onChange={handleChangeMaster}
                value={formMasterList.refBillNo || ""}
                disabled={false}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right" />
        </div>
        <hr />
        <div className="row mt-2">
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>รายละเอียดเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark1"
                value={formMasterList.docRemark1 || ""}
                onChange={handleChangeMaster}
                maxLength={100}
                disabled={
                  formMasterList.docStatusPaid === 3 ||
                    window.location.pathname === "/bill"
                    ? true
                    : false
                }
              />
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>หมายเหตุธุรการ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark2"
                value={formMasterList.docRemark2 || ""}
                onChange={handleChangeMaster}
                maxLength={500}
                disabled={
                  formMasterList.docStatusPaid === 3 ||
                    window.location.pathname === "/bill"
                    ? true
                    : false
                }
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <ItemTable
            formDetailList={formDetailList}
            handleChangeDetail={handleChangeDetail}
            handleDuplicateRow={handleDuplicateRow}
            handleRemoveRow={handleRemoveRow}
            formatCurrency={formatCurrency}
            showItemModal={showItemModal}
            handleItemClose={handleItemClose}
            itemDataList={itemDataList}
            onRowSelectItem={onRowSelectItem}
            handleItemShow={handleItemShow}
            whDataList={whDataList}
            showWarehouseModal={showWarehouseModal}
            handleWarehouseClose={handleWarehouseClose}
            handleWarehouseShow={handleWarehouseShow}
            onRowSelectWh={onRowSelectWh}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            disabled={
              formMasterList.docStatusPaid === 3 ||
                window.location.pathname === "/bill"
                ? true
                : false
            }
          />
          <Summary
            formMasterList={formMasterList}
            handleChangeMaster={handleChangeMaster}
            selectedDiscountValueType={selectedDiscountValueType}
            handleCheckboxChange={handleCheckboxChange}
            receiptDiscount={receiptDiscount}
            formatCurrency={formatCurrency}
            totalPrice={totalPrice}
            subFinal={subFinal}
            isVatChecked={isVatChecked}
            handleVatChange={handleVatChange}
            vatAmount={vatAmount}
            grandTotal={grandTotal}
            disabled={
              formMasterList.docStatusPaid === 3 ||
                window.location.pathname === "/bill"
                ? true
                : false
            }
          />
          <div
            hidden={
              window.location.pathname === "/bill" ||
              window.location.pathname === "/picking-list"
            }
          >
            <PaymentModal
              show={showPayTypeModal}
              grandTotal={grandTotal}
              paymentType={paymentType}
              setPaymentType={setPaymentType}
              paymentAmount={paymentAmount}
              setPaymentAmount={setPaymentAmount}
              handlePayTypeClose={handlePayTypeClose}
              handleUpdatePayment={handleUpdatePayment}
              handleUploadSlip={handleUploadSlip}
              base64Image={base64Image}
              setBase64Image={setBase64Image}
              chequeNo={chequeNo}
              setChequeNo={setChequeNo}
              chequeName={chequeName}
              setChequeName={setChequeName}
              chequeBranch={chequeBranch}
              setChequeBranch={setChequeBranch}
            />
          </div>
        </div>
      </div>

      <FormAction
        onSubmit={() => parseCurrency(grandTotal) === 0 ? getAlert("FAILED", "กรุณาเพิ่มรายการ หรือ ใส่จำนวนเงินก่อนบันทึก") : handleSubmit()}
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        onApprovedPay={handlePayTypeShow}
        onSubmitTax={handleTax}
        onUpdatePaid={handleUpdatePaidStatus}
        docStatus={formMasterList.docStatusPaid}
        mode={mode}
        disabled={false}
        disabledInv={formMasterList.docIsInv === "Y" ? true : false}
        disabledPay={isBl}
        footer={true}
      />
    </>
  );
}

export default Form;
